"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);

























const initialState = {}

const omitKey =  (record, key) =>
  Object.fromEntries(Object.entries(record).filter(([entryKey]) => entryKey !== key))

const removeEntry = (
  state,
  ConversationKey,
  MessageKey,
  Emoji,
) => {
  const conversation = state[ConversationKey]
  const message = _optionalChain([conversation, 'optionalAccess', _ => _[MessageKey]])
  if (!_optionalChain([message, 'optionalAccess', _2 => _2[Emoji]])) return state

  const nextMessage = omitKey(message, Emoji)
  if (Object.keys(nextMessage).length > 0) {
    return {
      ...state,
      [ConversationKey]: {
        ...conversation,
        [MessageKey]: nextMessage,
      },
    }
  }

  const nextConversation = omitKey(conversation , MessageKey)
  if (Object.keys(nextConversation).length > 0) {
    return { ...state, [ConversationKey]: nextConversation }
  }

  return omitKey(state, ConversationKey) 
}

const removeByOpId = (
  state,
  ConversationKey,
  opId,
) => {
  const conversation = state[ConversationKey]
  if (!conversation) return state

  for (const [messageKey, pendingByEmoji] of Object.entries(conversation)) {
    const matchingEmoji = _optionalChain([Object, 'access', _3 => _3.entries, 'call', _4 => _4(pendingByEmoji)
, 'access', _5 => _5.find, 'call', _6 => _6(([, entry]) => entry.opId === opId), 'optionalAccess', _7 => _7[0]])
    if (matchingEmoji) {
      return removeEntry(state, ConversationKey, messageKey , matchingEmoji)
    }
  }

  return state
}

const authoritativeHasReaction = (
  message,
  emoji,
  currentUserKey,
) => (_optionalChain([message, 'optionalAccess', _8 => _8.Reactions]) || []).some(
  reaction => reaction.Emoji === emoji && reaction.UserKey === currentUserKey,
)

 function pendingReactionsReducer (
  state = initialState,
  action,
  globalState,
) {
  switch (action.type) {
    case _actionCreators2.default.addMessageReactionActions.REQUEST.type:
    case _actionCreators2.default.removeMessageReactionActions.REQUEST.type: {
      const { ConversationKey, opId } = action.meta
      const { MessageKey, Emoji } = action.payload
      const existing = _optionalChain([state, 'access', _9 => _9[ConversationKey], 'optionalAccess', _10 => _10[MessageKey], 'optionalAccess', _11 => _11[Emoji]])
      const authoritativeMessage = _optionalChain([globalState, 'access', _12 => _12.messages, 'access', _13 => _13[ConversationKey], 'optionalAccess', _14 => _14.find, 'call', _15 => _15(
        message => message.MessageKey === MessageKey,
      )])
      const baseline = _nullishCoalesce(_optionalChain([existing, 'optionalAccess', _16 => _16.baseline]), () => ( authoritativeHasReaction(
        authoritativeMessage,
        Emoji,
        globalState.currentUser.UserKey,
      )))
      const entry = {
        op: action.type === _actionCreators2.default.addMessageReactionActions.REQUEST.type ? 'add' : 'remove',
        opId,
        at: new Date().toISOString(),
        baseline,
      }

      return {
        ...state,
        [ConversationKey]: {
          ...(state[ConversationKey] || {}),
          [MessageKey]: {
            ...(_optionalChain([state, 'access', _17 => _17[ConversationKey], 'optionalAccess', _18 => _18[MessageKey]]) || {}),
            [Emoji]: entry,
          },
        },
      }
    }

    case _actionCreators2.default.addMessageReactionActions.FAILURE.type:
    case _actionCreators2.default.removeMessageReactionActions.FAILURE.type: {
      const { ConversationKey, opId } = action.meta
      return removeByOpId(state, ConversationKey, opId)
    }

    case _actionCreators2.default.expirePendingReactionAction.type: {
      const { ConversationKey, MessageKey, Emoji, opId } = action.payload
      const entry = _optionalChain([state, 'access', _19 => _19[ConversationKey], 'optionalAccess', _20 => _20[MessageKey], 'optionalAccess', _21 => _21[Emoji]])
      return _optionalChain([entry, 'optionalAccess', _22 => _22.opId]) === opId
        ? removeEntry(state, ConversationKey, MessageKey, Emoji)
        : state
    }

    case _actionCreators2.default.updateNotificationAction.type:
    case _actionCreators2.default.loadConversationActions.SUCCESS.type:
    case _actionCreators2.default.loadConversationAroundTimeActions.SUCCESS.type:
    case _actionCreators2.default.loadConversationAroundMessageActions.SUCCESS.type: {
      const currentUserKey = globalState.currentUser.UserKey

      const conversations = (action.payload.Conversations || {}) 

      let nextState = state

      Object.entries(conversations).forEach(([mapConversationKey, conversation]) => {
        const conversationKey =
          (conversation.ConversationKey || mapConversationKey) 

        Object.values(conversation.Messages || {}).forEach(message => {
          const pendingForMessage = _optionalChain([nextState, 'access', _23 => _23[conversationKey], 'optionalAccess', _24 => _24[message.MessageKey]])
          if (!pendingForMessage) return

          Object.entries(pendingForMessage).forEach(([emoji, entry]) => {
            const desired = entry.op === 'add'
            const matches = authoritativeHasReaction(message, emoji, currentUserKey) === desired
            if (matches && desired !== entry.baseline) {
              nextState = removeEntry(nextState, conversationKey, message.MessageKey, emoji)
            }
          })
        })
      })

      return nextState
    }

    case _actionCreators2.default.logoutAction.type:
      return Object.keys(state).length > 0 ? initialState : state
  }

  return state
} exports.default = pendingReactionsReducer;
